module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [(_vm.wrap) ? _c('div', {
    staticClass: "hiui-spinner-content"
  }, [_c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true,
      "color": _vm.color,
      "size": _vm.size
    }
  }), _vm._v(" "), _vm._t("default")], 2) : _c('Icon', {
    attrs: {
      "name": "loading",
      "rotate": true,
      "color": _vm.color,
      "size": _vm.size
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b093a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner/Spinner.vue
// module id = 615
// module chunks = 0